// What a screen reader says for a fraction drawn by MathText.
const DENOMINATOR_WORDS: Record<number, [string, string]> = {
  2: ['half', 'halves'],
  3: ['third', 'thirds'],
  4: ['quarter', 'quarters'],
  5: ['fifth', 'fifths'],
  6: ['sixth', 'sixths'],
  7: ['seventh', 'sevenths'],
  8: ['eighth', 'eighths'],
  9: ['ninth', 'ninths'],
  10: ['tenth', 'tenths'],
  11: ['eleventh', 'elevenths'],
  12: ['twelfth', 'twelfths'],
  13: ['thirteenth', 'thirteenths'],
  14: ['fourteenth', 'fourteenths'],
  15: ['fifteenth', 'fifteenths'],
  16: ['sixteenth', 'sixteenths'],
  17: ['seventeenth', 'seventeenths'],
  18: ['eighteenth', 'eighteenths'],
  19: ['nineteenth', 'nineteenths'],
  20: ['twentieth', 'twentieths'],
  100: ['hundredth', 'hundredths'],
};

// e.g. "3 quarters", "1 and 1 half", "5 over 23".
export function spokenFraction(
  numerator: number,
  denominator: number,
  whole?: number,
): string {
  const words = DENOMINATOR_WORDS[denominator];
  const part = words
    ? `${String(numerator)} ${numerator === 1 ? words[0] : words[1]}`
    : `${String(numerator)} over ${String(denominator)}`;
  return whole === undefined ? part : `${String(whole)} and ${part}`;
}
